module.exports = __webpack_public_path__ + "static/img/logo.a4fd32f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/logo.png
// module id = 208e
// module chunks = 11